/*!
  Machina, by Whiley Mai
  navigation.js
  https://whileymai.com
*/

document.addEventListener("DOMContentLoaded", function () {
  headerMenuSlider();
  megaMenuAutoClose();
});
document.addEventListener("shopify:section:load", function () {
  headerMenuSlider();
  megaMenuAutoClose();
});
document.addEventListener("shopify:section:unload", function () {
  headerMenuSlider();
  megaMenuAutoClose();
});
document.addEventListener("shopify:section:reorder", function () {
  headerMenuSlider();
  megaMenuAutoClose();
});
function megaMenuAutoClose() {
  //  Megamenu on mouse leave auto close
  var megaMenus = document.querySelectorAll(".has-megamenu, .has-dropdown");
  if (megaMenus.length > 0) {
    megaMenus.forEach(function (megamenu) {
      var currentMenuWrp = megamenu.querySelector(".sub-menu");
      if (currentMenuWrp != null) {
        currentMenuWrp.onmouseleave = function () {
          document.activeElement.blur();
        };
      }
    });
  }
  // Close mega menu on click btn
  var megaMenuClose = document.querySelectorAll(".close-megamenu");
  if (megaMenuClose.length > 0) {
    megaMenuClose.forEach(function (close) {
      var currentMenuWrp = close.closest(".sub-menu.megamenu");
      close.onclick = function () {
        if (currentMenuWrp != null) {
          currentMenuWrp.classList.add("hide-megamenu");
          setTimeout(function () {
            currentMenuWrp.classList.remove("hide-megamenu");
          }, 1000);
        }
      };
    });
  }
}
function headerMenuSlider() {
  if (
    document.querySelector(".menu-slider-active") != null &&
    document.querySelector(".menu-items-slider") != null
  ) {
    var slider = tns({
      container: ".menu-items-slider",
      items: 5,
      gutter: 0,
      slideBy: 1,
      controlsPosition: "bottom",
      navPosition: "bottom",
      mouseDrag: false,
      autoplay: false,
      loop: false,
      preventScrollOnTouch: "force",
      autoplayButtonOutput: false,
      controlsContainer: "#custom-menu-slider-controls",
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  (function () {
    //prevent scrollto top
    const paginationBtns = document.querySelectorAll(".menu-account");
    paginationBtns.forEach((item, i) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
      });
    });
    //open menu
    function openMenu(e) {
      let t = e || document.body,
        o = t.querySelector(".js-menufloat-show"),
        a = t.querySelector(".menu-float__wrapper"),
        r = t.querySelectorAll(".menu-float__layout--primary a"),
        l = t.querySelectorAll(".menu-main"),
        c = document.getElementById("menu-filters"),
        d = t.querySelector(".filters");
      r.forEach(function (i) {
        var s = i ? i.dataset.childmenu : null;
        var m = s ? t.querySelector("." + s) : null;
        document.onmousemove = function (e) {
          var target = e.target;
          if (target.closest(".menu-float__wrapper") == null) {
            if (a.classList.contains("is-open")) {
              a.classList.remove("is-open-main-ignore");
              a.classList.remove("is-open");
              l.forEach(function (item) {
                item.classList.remove("is-active");
                item
                  .querySelector(".menu-float__menu-content")
                  .classList.remove("is-show");
              });
            }
          }
        };
        i.onmouseenter = function (e) {
          var target = e.target;
          // hide other megamenus
          if (a.classList.contains("is-open")) {
            a.classList.remove("is-open-main-ignore");
            a.classList.remove("is-open");
            l.forEach(function (item) {
              item.classList.remove("is-active");
              item
                .querySelector(".menu-float__menu-content")
                .classList.remove("is-show");
            });
          }
          // enable current mega menu
          if (i == target.closest(".menu-float__layout--primary a")) {
            a.classList.add("is-open-main-ignore");
            setTimeout(function () {
              a.classList.add("is-open");
            }, 100);
            if (m != null) {
              setTimeout(function () {
                m.classList.add("is-active");
              }, 100);
              setTimeout(function () {
                m.querySelector(".menu-float__menu-content").classList.add(
                  "is-show"
                );
                if (
                  m.querySelector(".menu-float__menu-content").offsetHeight >
                  600
                ) {
                  m.style.height = "80vh";
                }
              }, 200);
            }
          }
        };
      });
    }
    openMenu();
  })();

  //js button click
  var keepMenuOpen = function keepMenuOpen() {
    if (!document.body.classList.contains("show-sidebar-main")) {
      document.body.classList.add("show-sidebar-main");
      document.body.classList.add("active");
      console.log("Menu opened");
    }
  }; //close mobile menu

  var keepMenuClosed = function keepMenuClosed() {
    if (document.body.classList.contains("show-sidebar-main")) {
      document.body.classList.remove("show-sidebar-main");
      document.body.classList.remove("active");
      var menuOverlay = document.querySelector(".menu-popup-background");

      if (menuOverlay) {
        menuOverlay.remove();
      }

      console.log("Menu closed");
    }
  }; //create menu overlay

  const menuToggle = document.querySelector("li.js-menu-toggle-home");
  if(menuToggle != null) {
    menuToggle.onclick = function (e) {
      keepMenuOpen();
    };
  }
  //keep menu open when clicking inside sidebar

  const asideMain = document.querySelector("#aside_main");
  if (asideMain != null) {
    asideMain.onclick = function (e) {
      document.body.removeEventListener("click", closeSidebar);
      var closeBtn = document.querySelector("#aside_main .js-close-menu");
      var target = e.target;
      keepMenuOpen();
      if (target.closest("#aside_main .js-close-menu") == closeBtn) {
        //keepMenuClosed();
      }
    }; //close sidebar when clicked on overlay
  }
  var closeSidebar = function closeSidebar(e) {
    passive: true;

    var container = document.querySelector("#aside_main");
    var $body = document.body;

    if (
      !(container.classList[0] === e.target.classList[0]) &&
      container.querySelector(e.target.classList[0]) == null
    ) {
      if ($body.classList.contains("show-sidebar-main")) {
        keepMenuClosed();
      }
    }
  }; //invoke event listeners

  var closeBtn = document.querySelector("#aside_main .js-close-menu");
  if (closeBtn != null) {
    closeBtn.onclick = function (e) {
      keepMenuClosed();
      console.log("test");
    };
  }
  console.log("navigation dev file loaded");
});
